import React from 'react'
import Theme from '../../theme'

export const ArrowRight = ({ title, ...rest }) => (
  <svg
    width="54px"
    height="28px"
    viewBox="0 0 54 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>{title ?? ''}</title>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-485.000000, -5221.000000)">
        <g transform="translate(480.000000, 5203.000000)">
          <path d="M45.1927968,18.5044444 L59,32.0074301 L45.1934127,45.495929 C44.5112199,46.1624048 43.4224323,46.1646612 42.737483,45.5010186 C42.0753383,44.8594713 42.0586408,43.80262 42.7001882,43.1404753 C42.710236,43.1301048 42.720418,43.1198652 42.7307315,43.1097589 L52.403,33.631 L6.69398207,33.6312857 C5.80766163,33.6312857 5.08032454,32.93706 5.00621793,32.0526849 L5,31.9036149 C5,30.9494486 5.75842161,30.1759441 6.69398207,30.1759441 L6.69398207,30.1759441 L52.193,30.175 L42.7299951,20.8907353 C42.0714756,20.2446584 42.0613889,19.1870741 42.7074657,18.5285546 L42.737483,18.4987247 L42.737483,18.4987247 C43.4223325,17.8351789 44.5110462,17.8377151 45.1927968,18.5044444 Z"></path>
        </g>
      </g>
    </g>
  </svg>
)

export const Chevron = ({
  size = '40',
  direction = 'right',
  color = Theme.colors.white,
  ...rest
}) => {
  const getTransform = () => {
    switch (direction) {
      case 'up':
        return 'rotate(-90 20 20)'
      case 'down':
        return 'rotate(90 20 20)'
      case 'left':
        return 'rotate(180 20 20)'
      default:
        return 'rotate(0)'
    }
  }

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      {...rest}
    >
      <path
        fill={color}
        transform={getTransform()}
        d="M25.45 20.01L25.45 20.01C18.65 13.34 14.87 9.63 14.12 8.89C13.46 8.24 13.45 7.19 14.09 6.53C14.1 6.52 14.11 6.51 14.12 6.5C14.81 5.84 15.9 5.84 16.58 6.5C17.5 7.4 22.1 11.91 30.39 20.01L30.39 20.01C22.1 28.1 17.5 32.6 16.58 33.5C15.9 34.16 14.81 34.16 14.12 33.5C13.46 32.86 13.44 31.8 14.09 31.14C14.1 31.13 14.11 31.12 14.12 31.11C15.63 29.63 19.4 25.93 25.45 20.01Z"
      />
    </svg>
  )
}

export const ChevronUp = (props) => {
  return (
    <svg
      width="29px"
      height="18px"
      viewBox="0 0 29 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-338.000000, -5226.000000)">
          <g transform="translate(320.000000, 5203.000000)">
            <path
              d="M24.5013012,43.1070324 L35.8313531,32.0047035 L35.8313531,32.0047035 L24.5005648,20.8880088 C23.8420453,20.2419319 23.8319585,19.1843475 24.4780354,18.525828 C24.4879148,18.5157584 24.4979214,18.5058143 24.5080527,18.4959981 C25.1929021,17.8324523 26.2816159,17.8349885 26.9633664,18.5017179 L40.7705697,32.0047035 L40.7705697,32.0047035 L26.9639823,45.4932024 C26.2817896,46.1596782 25.193002,46.1619346 24.5080527,45.4982921 C23.8459079,44.8567447 23.8292105,43.7998934 24.4707578,43.1377487 C24.4808057,43.1273783 24.4909877,43.1171386 24.5013012,43.1070324 Z"
              transform="translate(32.385285, 31.997273) rotate(-90.000000) translate(-32.385285, -31.997273)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Facebook = () => {
  return (
    <svg
      width="13px"
      height="24px"
      viewBox="0 0 13 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Facebook</title>
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-980.000000, -9559.000000)">
          <g transform="translate(0.000000, 9498.000000)">
            <g transform="translate(965.000000, 52.000000)">
              <g>
                <path d="M24.5,13 L27.5,13 C27.7761424,13 28,12.7761424 28,12.5 L28,9.5 C28,9.22385763 27.7761424,9 27.5,9 L24.5,9 C21.4638047,9.0033068 19.0033068,11.4638047 19,14.5 L19,18 L15.5,18 C15.2238576,18 15,18.2238576 15,18.5 L15,21.5 C15,21.7761424 15.2238576,22 15.5,22 L19,22 L19,32.5 C19,32.7761424 19.2238576,33 19.5,33 L22.5,33 C22.7761424,33 23,32.7761424 23,32.5 L23,22 L26.5,22 C26.7152881,21.9996485 26.9063825,21.8620605 26.975,21.658 L27.975,18.658 C28.0253413,18.5054488 27.9994769,18.3380095 27.9054509,18.2077588 C27.811425,18.0775082 27.6606426,18.0002451 27.5,18 L23,18 L23,14.5 C23,13.673 23.673,13 24.5,13 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const LinkedIn = () => {
  return (
    <svg
      width="20px"
      height="18px"
      viewBox="0 0 20 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LinkedIn</title>
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-1081.000000, -9561.000000)">
          <g transform="translate(0.000000, 9498.000000)">
            <g transform="translate(965.000000, 52.000000)">
              <g transform="translate(103.500000, 0.000000)">
                <g transform="translate(13.000000, 11.000000)">
                  <circle cx="2.25" cy="2.25" r="2.25"></circle>
                  <path d="M4.125,6 L0.375,6 C0.167893219,6 0,6.16789322 0,6.375 L0,17.625 C0,17.8321068 0.167893219,18 0.375,18 L4.125,18 C4.33210678,18 4.5,17.8321068 4.5,17.625 L4.5,6.375 C4.5,6.16789322 4.33210678,6 4.125,6 Z"></path>
                  <path d="M16.29775,5.48325 C14.695,4.93425 12.69025,5.4165 11.488,6.28125 C11.4452587,6.11571381 11.295965,6.00004203 11.125,6 L7.375,6 C7.16789322,6 7,6.16789322 7,6.375 L7,17.625 C7,17.8321068 7.16789322,18 7.375,18 L11.125,18 C11.3321068,18 11.5,17.8321068 11.5,17.625 L11.5,9.54 C12.106,9.018 12.88675,8.8515 13.52575,9.123 C14.14525,9.38475 14.5,10.02375 14.5,10.875 L14.5,17.625 C14.5,17.8321068 14.6678932,18 14.875,18 L18.625,18 C18.8321068,18 19,17.8321068 19,17.625 L19,10.11975 C18.95725,7.038 17.5075,5.89725 16.29775,5.48325 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Pinterest = () => {
  return (
    <svg
      width="21px"
      height="24px"
      viewBox="0 0 21 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Pinterest</title>
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-1132.000000, -9559.000000)">
          <g transform="translate(0.000000, 9498.000000)">
            <g transform="translate(965.000000, 52.000000)">
              <g transform="translate(155.500000, 0.000000)">
                <g transform="translate(12.000000, 9.000000)">
                  <path d="M10.5,0 C1.886,0 0,6.497 0,9 C0,11.813 2.691,16 4.5,16 C4.72331651,15.999724 4.91948779,15.8516779 4.981,15.637 L5.375,14.257 L4.01,20.398 C3.994,20.477 3.629,22.336 5.146,23.853 C5.30555462,24.0132563 5.55281053,24.0464698 5.749,23.934 C5.814,23.896 7.363,22.996 7.954,21.709 C8.366,20.814 9.308,18.392 9.742,17.265 C10.5818549,17.7454744 11.5324203,17.9987977 12.5,18 C18.036,18 20,13.152 20,9 C20,5.887 18.015,0 10.5,0 Z M5.978,11.545 L5.932,11.752 C5.89947564,11.6947331 5.85597953,11.6444408 5.804,11.604 C5.771,11.578 5,10.954 5,9.5 C5,6.064 7.851,4.5 10.5,4.5 C13.279,4.5 15,6.576 15,8.5 C15,10.556 13.122,14 12,14 C10.804,14 10.561,13.094 10.512,12.684 C11.639,11.387 12,9.069 12,8.465 C12.001,8.107 12.003,7.361 11.406,6.762 C10.902,6.256 10.092,6 9,6 C6.237,6 5.5,8.2 5.5,9.5 C5.5,10.26 5.834,11.183 5.978,11.545 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Youtube = () => {
  return (
    <svg
      width="25px"
      height="18px"
      viewBox="0 0 25 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Youtube</title>
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-1182.000000, -9562.000000)">
          <g transform="translate(0.000000, 9498.000000)">
            <g transform="translate(965.000000, 52.000000)">
              <g transform="translate(207.500000, 0.000000)">
                <g transform="translate(10.000000, 12.000000)">
                  <path d="M20.803,0.764 L15.509,0.304 C13.1740706,0.100999132 10.8259294,0.100999132 8.491,0.304 L3.197,0.764 C1.38366492,0.911927841 -0.0096834366,2.43166688 -5.01652869e-05,4.251 L-5.01652869e-05,13.75 C-0.0096834366,15.5693331 1.38366492,17.0890722 3.197,17.237 L8.491,17.697 C9.655,17.799 10.827,17.849 12,17.849 C13.173,17.849 14.345,17.799 15.509,17.697 L20.803,17.237 C22.615878,17.0881383 24.0087135,15.5689586 24.0000502,13.75 L24.0000502,4.251 C24.0096834,2.43166688 22.6163351,0.911927841 20.803,0.764 Z M8.99999596,4.5 C8.99926456,4.31685588 9.09891576,4.14802602 9.25961065,4.06016557 C9.42030555,3.97230511 9.61621782,3.97953468 9.77,4.079 L16.77,8.579 C16.9131412,8.67084544 16.9997805,8.82915375 16.9999831,8.99922713 C17.000185,9.16930051 16.9139224,9.32781441 16.771,9.42 L9.771,13.92 C9.6166948,14.0175629 9.42179948,14.0244415 9.261,13.938 C9.09987435,13.8513138 8.99955627,13.6829639 8.99999596,13.5 L8.99999596,4.5 L8.99999596,4.5 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Instagram = () => {
  return (
    <svg
      width="25px"
      height="24px"
      viewBox="0 0 25 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Instagram</title>
      <g stroke="none" strokeWidth="1">
        <g transform="translate(-1026.000000, -9559.000000)">
          <g transform="translate(0.000000, 9498.000000)">
            <g transform="translate(965.000000, 52.000000)">
              <g transform="translate(61.500000, 9.000000)">
                <path d="M12,2.162 C15.204,2.162 15.584,2.174 16.849,2.232 C18.215,2.294 19.482,2.568 20.457,3.543 C21.432,4.518 21.706,5.785 21.768,7.151 C21.826,8.416 21.838,8.796 21.838,12 C21.838,15.204 21.826,15.584 21.768,16.849 C21.706,18.215 21.432,19.482 20.457,20.457 C19.482,21.432 18.215,21.706 16.849,21.768 C15.584,21.826 15.204,21.838 12,21.838 C8.796,21.838 8.416,21.826 7.151,21.768 C5.785,21.706 4.518,21.432 3.543,20.457 C2.568,19.482 2.294,18.215 2.232,16.849 C2.174,15.584 2.162,15.204 2.162,12 C2.162,8.796 2.174,8.416 2.232,7.151 C2.294,5.785 2.568,4.518 3.543,3.543 C4.518,2.568 5.785,2.294 7.151,2.232 C8.416,2.174 8.796,2.162 12,2.162 M12,0 C8.741,0 8.332,0.014 7.052,0.072 C5.102,0.161 3.389,0.639 2.014,2.014 C0.639,3.389 0.161,5.102 0.072,7.052 C0.014,8.332 0,8.741 0,12 C0,15.259 0.014,15.668 0.072,16.948 C0.161,18.898 0.639,20.611 2.014,21.986 C3.389,23.361 5.102,23.839 7.052,23.928 C8.332,23.986 8.741,24 12,24 C15.259,24 15.668,23.986 16.948,23.928 C18.898,23.839 20.611,23.361 21.986,21.986 C23.361,20.611 23.839,18.898 23.928,16.948 C23.986,15.668 24,15.259 24,12 C24,8.741 23.986,8.332 23.928,7.052 C23.839,5.102 23.361,3.389 21.986,2.014 C20.611,0.639 18.898,0.161 16.948,0.072 C15.668,0.014 15.259,0 12,0 L12,0 Z"></path>
                <path d="M12,5.838 C8.597,5.838 5.838,8.597 5.838,12 C5.838,15.403 8.597,18.162 12,18.162 C15.403,18.162 18.162,15.403 18.162,12 C18.162,8.597 15.403,5.838 12,5.838 Z M12,16 C9.791,16 8,14.209 8,12 C8,9.791 9.791,8 12,8 C14.209,8 16,9.791 16,12 C16,14.209 14.209,16 12,16 Z"></path>
                <circle cx="18.406" cy="5.594" r="1.44"></circle>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Orb1 = (props) => {
  return (
    <svg
      height="347"
      viewBox="0 0 379 347"
      width="379"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className ? props.className : ''}
    >
      <path
        d="M350.45 83.65C376.31 124.3 384.11 164.28 373.8 203.77C363.38 243.34 336 278.06 291.45 308.09C243.76 340.23 196.04 352.05 148.19 343.61C100.44 335.12 61.41 308.53 31.14 263.69C4.03 223.54 -5.25 183.91 3.24 144.99C11.85 106.01 37.13 72.38 79.09 44.1C118.78 17.36 157.15 2.88 194.13 0.57C231.13 -1.74 264.6 8.24 294.52 30.88C321.44 50.15 338.92 68.09 350.45 83.65"
        fillRule="evenodd"
        fill={props.fill ? props.fill : ''}
      />
    </svg>
  )
}

export const Orb2 = (props) => {
  return (
    <svg
      width="309px"
      height="336px"
      viewBox="0 0 309 336"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className ? props.className : ''}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill={props.fill ? props.fill : ''}
        fillRule="evenodd"
      >
        <g
          transform="translate(-907.000000, -7680.000000)"
          fill={props.fill ? props.fill : ''}
        >
          <g transform="translate(64.000000, 7632.000000)">
            <g>
              <path
                d="M835.184963,214.707358 C833.354409,171.767786 845.108915,137.403294 870.560558,111.485536 C896.129612,85.56243 932.588597,70.941745 980.153655,67.6074373 C1031.06761,64.0405035 1072.98624,76.1825172 1106.01894,104.036152 C1138.9449,131.892461 1157.1357,169.831909 1160.49527,217.980167 C1163.50528,261.082845 1153.04764,295.837721 1129.24777,322.124473 C1105.32514,348.405876 1070.96889,363.117472 1026.16835,366.256588 C983.798753,369.224576 947.8868,363.299295 918.435156,348.593046 C888.978176,333.886798 867.683973,311.252544 854.739339,280.420225 C842.608581,253.526507 837.135597,231.876235 835.184963,214.707358"
                transform="translate(998.000000, 217.000000) rotate(-120.000000) translate(-998.000000, -217.000000)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Orb3 = (props) => {
  return (
    <svg
      width="433px"
      height="396px"
      viewBox="0 0 433 396"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className ? props.className : ''}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill={props.fill ? props.fill : ''}
        fillRule="evenodd"
      >
        <g
          transform="translate(-561.000000, -7844.000000)"
          fill={props.fill ? props.fill : ''}
        >
          <g transform="translate(64.000000, 7632.000000)">
            <g>
              <path d="M497.245361,406.973713 C494.817058,350.293477 510.409876,304.932348 544.172485,270.720907 C578.090846,236.502408 626.45513,217.203103 689.55206,212.801817 C757.091439,208.093465 812.698152,224.120923 856.517333,260.887721 C900.194922,297.658049 924.325736,347.73812 928.782344,411.293821 C932.775238,468.189355 918.902763,514.065792 887.33129,548.764304 C855.596985,583.455756 810.022064,602.875063 750.592366,607.018696 C694.387426,610.936441 646.748802,603.115069 607.680032,583.702821 C568.604183,564.290573 540.356581,534.413358 523.185013,493.714697 C507.093083,458.214989 499.832954,429.63663 497.245361,406.973713"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Orb4 = (props) => {
  return (
    <svg
      width="309px"
      height="337px"
      viewBox="0 0 309 337"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className ? props.className : ''}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill={props.fill ? props.fill : ''}
        fillRule="evenodd"
      >
        <g
          transform="translate(-676.000000, -11348.000000)"
          fill={props.fill ? props.fill : ''}
        >
          <g transform="translate(64.000000, 11301.000000)">
            <g transform="translate(876.500000, 321.500000) scale(-1, 1) translate(-876.500000, -321.500000) translate(554.000000, 0.000000)">
              <g>
                <path
                  d="M270.184963,214.560051 C268.354409,171.620479 280.108915,137.255986 305.560558,111.338228 C331.129612,85.4151226 367.588597,70.7944375 415.153655,67.4601299 C466.067614,63.8931961 507.98624,76.0352098 541.018939,103.888845 C573.9449,131.745154 592.1357,169.684601 595.495274,217.83286 C598.505282,260.935538 588.04764,295.690414 564.247766,321.977165 C540.325143,348.258568 505.968895,362.970165 461.168347,366.10928 C418.798753,369.077269 382.8868,363.151988 353.435156,348.445739 C323.978176,333.73949 302.683973,311.105237 289.739339,280.272918 C277.608581,253.3792 272.135597,231.728928 270.184963,214.560051"
                  transform="translate(433.000000, 216.852693) rotate(-120.000000) translate(-433.000000, -216.852693)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const PlayButton = ({
  backgroundColor = Theme.colors.brand,
  triangleColor = Theme.colors.white,
  size = '114px',
  ...rest
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 230 230"
    width={size}
    height={size}
    {...rest}
  >
    <path
      fill={backgroundColor}
      d="M0.13 113.4C-1.16 83.34 7.13 59.28 25.09 41.14C43.13 22.99 68.85 12.76 102.41 10.43C138.33 7.93 167.9 16.43 191.21 35.93C214.44 55.42 227.27 81.98 229.64 115.69C231.77 145.86 224.39 170.19 207.6 188.59C190.72 206.98 166.48 217.28 134.87 219.48C104.98 221.56 79.64 217.41 58.87 207.12C38.08 196.82 23.06 180.98 13.93 159.39C5.37 140.57 1.51 125.41 0.13 113.4"
    />
    <path
      fill="none"
      stroke={triangleColor}
      strokeWidth="6"
      d="M148.99 112.67C149.55 113.01 149.54 113.83 148.98 114.17C137.84 120.88 104.78 140.79 93.43 147.63C93.36 147.67 93.29 147.62 93.29 147.55C93.29 133.75 93.29 93.11 93.29 79.46C93.29 79.06 93.73 78.81 94.07 79.02C105.3 85.9 137.85 105.84 148.99 112.67Z"
    />
  </svg>
)

export const Search = (props) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 18.25C4.66751 18.25 0.75 14.3325 0.75 9.5C0.75 4.66751 4.66751 0.75 9.5 0.75C14.3325 0.75 18.25 4.66751 18.25 9.5C18.25 11.4654 17.602 13.2795 16.508 14.7402L22.5339 20.7661C23.022 21.2543 23.022 22.0457 22.5339 22.5339C22.0457 23.022 21.2543 23.022 20.7661 22.5339L14.7402 16.508C13.2795 17.602 11.4654 18.25 9.5 18.25ZM9.5 15.75C12.9518 15.75 15.75 12.9518 15.75 9.5C15.75 6.04822 12.9518 3.25 9.5 3.25C6.04822 3.25 3.25 6.04822 3.25 9.5C3.25 12.9518 6.04822 15.75 9.5 15.75Z"
      fill="currentColor"
    />
  </svg>
)

export const Globe = (props) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8623 0C4.4623 0 0.862305 3.6 0.862305 8C0.862305 12.4 4.4623 16 8.8623 16C13.2623 16 16.8623 12.4 16.8623 8C16.8623 3.6 13.2623 0 8.8623 0ZM14.7623 7H12.8623C12.7623 5.5 12.4623 4.1 12.0623 2.9C13.4623 3.8 14.4623 5.3 14.7623 7ZM6.8623 9C7.0623 12.1 8.2623 14 8.8623 14C9.46231 14 10.6623 12.1 10.8623 9H6.8623ZM6.8623 7C7.0623 3.9 8.1623 2 8.8623 2C9.5623 2 10.6623 3.9 10.8623 7H6.8623ZM4.8623 7C4.9623 5.5 5.2623 4.1 5.7623 2.9C4.2623 3.8 3.2623 5.3 2.9623 7H4.8623ZM2.9623 9H4.8623C4.9623 10.5 5.2623 11.9 5.6623 13.1C4.2623 12.2 3.2623 10.7 2.9623 9ZM12.7623 9C12.6623 10.5 12.4623 11.9 11.9623 13.1C13.4623 12.2 14.4623 10.7 14.6623 9H12.7623Z"
      fill="currentColor"
    />
  </svg>
)

export const Download = (props) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.20161 0.167969C6.72228 0.167969 6.40172 0.487025 6.40172 0.966358V7.35797H3.60661C3.36694 7.35797 3.20667 7.51675 3.20667 7.75642C3.20667 7.8373 3.28606 7.99758 3.28606 8.07697L7.36039 11.991C7.52067 12.1513 7.68094 12.2307 7.92061 12.2307C8.16028 12.2307 8.31906 12.1513 8.47933 11.991L12.5537 8.07697C12.7124 7.99758 12.7933 7.8373 12.7933 7.75642C12.7933 7.51675 12.6331 7.35797 12.3934 7.35797H9.59828V0.966358C9.59828 0.487025 9.27772 0.167969 8.79839 0.167969H7.20161ZM0.809999 14.548C0.522398 14.5435 0.254271 14.6948 0.108973 14.9434C-0.0363245 15.1921 -0.0363245 15.5006 0.108973 15.7493C0.254271 15.998 0.522398 16.1492 0.809999 16.1448H15.19C15.4776 16.1492 15.7457 15.998 15.891 15.7493C16.0363 15.5006 16.0363 15.1921 15.891 14.9434C15.7457 14.6948 15.4776 14.5435 15.19 14.548H0.809999Z"
      fill="currentColor"
    />
  </svg>
)

export const Phone = (props) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.0856 10.4003L11.9486 9.00828C11.3106 8.72605 10.5626 8.90731 10.1246 9.45028L9.17763 10.6353C7.64297 9.65897 6.34134 8.35768 5.36463 6.82328L6.54863 5.87728C7.09357 5.43971 7.27582 4.69021 6.99263 4.05128L5.59963 0.91428C5.29402 0.226173 4.53542 -0.139797 3.80663 0.0492803L1.15463 0.73828C0.397366 0.936103 -0.0923431 1.66895 0.0146299 2.44428C1.02336 9.46306 6.53777 14.9771 13.5566 15.9853C13.6269 15.9952 13.6977 16.0002 13.7686 16.0003C14.4708 15.9999 15.0843 15.5257 15.2616 14.8463L15.9496 12.1933C16.1415 11.4645 15.7752 10.7043 15.0856 10.4003Z"
      fill="currentColor"
    />
  </svg>
)

export const Email = (props) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 0H1C0.4 0 0 0.4 0 1V2.4L8 6.9L16 2.5V1C16 0.4 15.6 0 15 0Z"
      fill="currentColor"
    />
    <path
      d="M7.5 8.89995L0 4.69995V13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13V4.69995L8.5 8.89995C8.22 9.03995 7.78 9.03995 7.5 8.89995Z"
      fill="currentColor"
    />
  </svg>
)

export const Location = (props) => (
  <svg
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0C3.1 0 0 3.1 0 7C0 8.9 0.7 10.7 2.1 12C2.2 12.1 6.2 15.7 6.3 15.8C6.7 16.1 7.3 16.1 7.6 15.8C7.7 15.7 11.8 12.1 11.8 12C13.2 10.7 13.9 8.9 13.9 7C14 3.1 10.9 0 7 0ZM7 9C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5C8.1 5 9 5.9 9 7C9 8.1 8.1 9 7 9Z"
      fill="currentColor"
    />
  </svg>
)

export const Info = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.314 0H4.686L0 4.686V11.314L4.686 16H11.314L16 11.314V4.686L11.314 0ZM8 12C7.73014 12.0162 7.46625 11.9161 7.27508 11.7249C7.08391 11.5338 6.98378 11.2699 7 11C6.98378 10.7301 7.08391 10.4662 7.27508 10.2751C7.46625 10.0839 7.73014 9.98378 8 10C8.26986 9.98378 8.53375 10.0839 8.72492 10.2751C8.91609 10.4662 9.01622 10.7301 9 11C9.01622 11.2699 8.91609 11.5338 8.72492 11.7249C8.53375 11.9161 8.26986 12.0162 8 12ZM7 9H9V4H7V9Z"
      fill="currentColor"
    />
  </svg>
)

export const DecledereDocument = (props) => (
  <svg
    viewBox="0 0 48 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.40625 1.89895C4.40625 1.11238 5.07782 0.474731 5.90625 0.474731H41.9062C42.7347 0.474731 43.4062 1.11238 43.4062 1.89895V22.7875C43.4062 23.5741 42.7347 24.2118 41.9062 24.2118C41.0778 24.2118 40.4062 23.5741 40.4062 22.7875V3.32317H7.40625V42.2519H22.0003C22.8287 42.2519 23.5003 42.8895 23.5003 43.6761C23.5003 44.4627 22.8287 45.1003 22.0003 45.1003H5.90625C5.07782 45.1003 4.40625 44.4627 4.40625 43.6761V1.89895Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 13.2928C12.5 12.5062 13.1716 11.8685 14 11.8685H33.906C34.7344 11.8685 35.406 12.5062 35.406 13.2928C35.406 14.0793 34.7344 14.717 33.906 14.717H14C13.1716 14.717 12.5 14.0793 12.5 13.2928Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 22.7875C12.5 22.0009 13.1716 21.3633 14 21.3633H33.906C34.7344 21.3633 35.406 22.0009 35.406 22.7875C35.406 23.5741 34.7344 24.2117 33.906 24.2117H14C13.1716 24.2117 12.5 23.5741 12.5 22.7875Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 32.2824C12.5 31.4958 13.1716 30.8582 14 30.8582H22C22.8284 30.8582 23.5 31.4958 23.5 32.2824C23.5 33.069 22.8284 33.7066 22 33.7066H14C13.1716 33.7066 12.5 33.069 12.5 32.2824Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.4717 27.4163C38.4862 27.3831 39.4978 27.5405 40.4482 27.8797C41.4077 28.222 42.2856 28.7428 43.0304 29.4114C43.6325 29.9517 43.6591 30.8531 43.09 31.4247C42.5209 31.9963 41.5716 32.0217 40.9696 31.4813C40.5147 31.0731 39.9786 30.7551 39.3927 30.546C38.8068 30.3369 38.1829 30.241 37.5574 30.2637C37.5383 30.2644 37.5191 30.2647 37.5 30.2647C35.5092 30.2647 34.2772 31.0218 33.4904 32.0703C32.6553 33.1832 32.25 34.7342 32.25 36.3177C32.25 37.9012 32.6553 39.4521 33.4904 40.565C34.2772 41.6135 35.5092 42.3706 37.5 42.3706C37.5191 42.3706 37.5383 42.371 37.5574 42.3717C38.1829 42.3944 38.8068 42.2985 39.3927 42.0894C39.9786 41.8803 40.5147 41.5623 40.9696 41.1541C41.5716 40.6137 42.5209 40.6391 43.09 41.2107C43.6591 41.7823 43.6325 42.6837 43.0304 43.224C42.2856 43.8926 41.4077 44.4133 40.4482 44.7557C39.4978 45.0949 38.4862 45.2523 37.4717 45.219C34.5271 45.2114 32.3935 44.0121 31.0471 42.2179C29.7447 40.4824 29.25 38.2947 29.25 36.3177C29.25 34.3406 29.7447 32.153 31.0471 30.4175C32.3935 28.6233 34.5271 27.424 37.4717 27.4163Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 34.1813C27 33.3947 27.6716 32.7571 28.5 32.7571H36.75C37.5784 32.7571 38.25 33.3947 38.25 34.1813C38.25 34.9679 37.5784 35.6055 36.75 35.6055H28.5C27.6716 35.6055 27 34.9679 27 34.1813Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 38.454C27 37.6674 27.6716 37.0298 28.5 37.0298H36.75C37.5784 37.0298 38.25 37.6674 38.25 38.454C38.25 39.2406 37.5784 39.8782 36.75 39.8782H28.5C27.6716 39.8782 27 39.2406 27 38.454Z"
      fill="#E50006"
    />
  </svg>
)

export const RetourInformation = (props) => (
  <svg
    viewBox="0 0 48 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 20.5142C16.299 20.5142 21 16.0507 21 10.5446C21 5.03859 16.299 0.575073 10.5 0.575073C4.70101 0.575073 0 5.03859 0 10.5446C0 16.0507 4.70101 20.5142 10.5 20.5142ZM10.5 17.6657C6.35786 17.6657 3 14.4775 3 10.5446C3 6.61174 6.35786 3.42352 10.5 3.42352C14.6421 3.42352 18 6.61174 18 10.5446C18 14.4775 14.6421 17.6657 10.5 17.6657ZM10.5 16.2415C13.8137 16.2415 16.5 13.6909 16.5 10.5446C16.5 7.39832 13.8137 4.84774 10.5 4.84774C7.18629 4.84774 4.5 7.39832 4.5 10.5446C4.5 13.6909 7.18629 16.2415 10.5 16.2415ZM10.5 13.3931C8.84315 13.3931 7.5 12.1178 7.5 10.5446C7.5 8.97147 8.84315 7.69618 10.5 7.69618C12.1569 7.69618 13.5 8.97147 13.5 10.5446C13.5 12.1178 12.1569 13.3931 10.5 13.3931ZM43.5 36.1806C43.5 39.3269 40.8137 41.8775 37.5 41.8775C34.1863 41.8775 31.5 39.3269 31.5 36.1806C31.5 33.0343 34.1863 30.4837 37.5 30.4837C40.8137 30.4837 43.5 33.0343 43.5 36.1806ZM34.5 36.1806C34.5 37.7538 35.8431 39.029 37.5 39.029C39.1569 39.029 40.5 37.7538 40.5 36.1806C40.5 34.6075 39.1569 33.3322 37.5 33.3322C35.8431 33.3322 34.5 34.6075 34.5 36.1806ZM37.5 46.1502C43.299 46.1502 48 41.6866 48 36.1806C48 30.6746 43.299 26.2111 37.5 26.2111C31.701 26.2111 27 30.6746 27 36.1806C27 41.6866 31.701 46.1502 37.5 46.1502ZM37.5 43.3017C33.3579 43.3017 30 40.1135 30 36.1806C30 32.2477 33.3579 29.0595 37.5 29.0595C41.6421 29.0595 45 32.2477 45 36.1806C45 40.1135 41.6421 43.3017 37.5 43.3017ZM25.5 11.9688C25.5 11.5803 25.6639 11.2281 25.9296 10.9711L25.9406 10.9606L31.9393 5.26488C32.5251 4.70869 33.4749 4.70869 34.0607 5.26488C34.6464 5.82107 34.6464 6.72284 34.0607 7.27903L30.6213 10.5446H36C40.1419 10.5446 43.5 13.733 43.5 17.6657V21.9384C43.5 22.725 42.8284 23.3626 42 23.3626C41.1716 23.3626 40.5 22.725 40.5 21.9384V17.6657C40.5 15.3062 38.4851 13.3931 36 13.3931H30.6213L34.0607 16.6587C34.6464 17.2148 34.6464 18.1166 34.0607 18.6728C33.4749 19.229 32.5251 19.229 31.9393 18.6728L25.9393 12.9759C25.7955 12.8394 25.687 12.682 25.6138 12.514C25.5405 12.3461 25.5 12.162 25.5 11.9688ZM7.5 29.0595C7.5 31.419 9.51493 33.3322 12 33.3322H17.3787L13.9393 30.0666C13.3536 29.5104 13.3536 28.6086 13.9393 28.0524C14.5251 27.4962 15.4749 27.4962 16.0607 28.0524L22.0599 33.7486L22.0607 33.7493M17.3787 36.1806H12C7.85807 36.1806 4.5 32.9922 4.5 29.0595V24.7868C4.5 24.0003 5.17157 23.3626 6 23.3626C6.82843 23.3626 7.5 24.0003 7.5 24.7868V29.0595M17.3787 36.1806L13.9393 39.4462C13.3536 40.0024 13.3536 40.9042 13.9393 41.4603C14.5251 42.0165 15.4749 42.0165 16.0607 41.4603L22.0599 35.7641L22.0607 35.7635M22.498 34.6831C22.4993 34.7074 22.5 34.7318 22.5 34.7564C22.5 35.1196 22.3546 35.4827 22.0638 35.7604M22.498 34.6831C22.4892 34.5167 22.4502 34.3578 22.3862 34.2112L22.498 34.6831ZM22.3862 34.2112C22.3135 34.0445 22.2061 33.8882 22.0638 33.7523L22.3862 34.2112Z"
      fill="#E50006"
    />
  </svg>
)

export const PdfFile = (props) => (
  <svg
    viewBox="0 0 40 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.6723 13.0657C18.0599 13.0657 17.4507 13.3609 17.1175 13.8276C16.7811 14.2944 16.6891 14.8696 16.7558 15.4629C16.8858 16.5741 17.5395 17.8479 18.3645 19.1218C18.171 19.7361 18.0123 20.3384 17.7648 20.9648C17.5141 21.5942 17.2095 22.1664 16.9176 22.7626C15.2104 23.4041 13.6461 24.1118 12.7164 24.964C12.2182 25.4187 11.9453 26.006 11.885 26.6053C11.8247 27.2075 12.0278 27.9514 12.7227 28.3037C13.3161 28.6079 13.9317 28.5055 14.4838 28.2977C15.0391 28.0899 15.5722 27.7315 16.0259 27.2437C16.7907 26.4185 17.4856 25.2441 18.1361 23.9732C18.5422 23.8257 18.8944 23.654 19.3165 23.5215C20.1478 23.2625 20.9696 23.0849 21.7883 22.8982C23.0195 23.8678 24.3331 24.6297 25.7769 24.6297C26.4337 24.6297 26.9668 24.5605 27.4301 24.2654C27.8934 23.9702 28.125 23.4071 28.125 22.9554C28.125 21.7809 27.043 20.7992 25.7039 20.7751C24.7329 20.757 23.5208 20.9226 22.2357 21.1846C21.8422 20.8413 21.4297 20.5823 21.0712 20.1758C20.7063 19.7632 20.4651 19.3115 20.1573 18.8688C20.5286 17.5829 20.7983 16.3603 20.8142 15.3906C20.8364 14.0776 19.8464 13.0657 18.6723 13.0657ZM18.6723 14.6076C18.7802 14.6076 19.199 14.7913 19.1895 15.3665C19.1832 15.7339 19.0436 16.3151 18.9484 16.824C18.7009 16.2669 18.4153 15.6706 18.374 15.2942C18.3328 14.963 18.4089 14.7642 18.4597 14.6919C18.5105 14.6227 18.5073 14.6076 18.6723 14.6076ZM19.5322 20.757C19.6465 20.8895 19.7099 21.0371 19.8273 21.1696C19.9923 21.3563 20.2081 21.4767 20.3826 21.6544C19.9352 21.7749 19.5068 21.8562 19.0594 21.9917C19.1292 21.8231 19.2181 21.6755 19.2879 21.5069C19.3863 21.2509 19.4402 21.01 19.5322 20.757ZM25.6722 22.3169C26.3258 22.329 26.5004 22.5639 26.5004 22.9554C26.5004 22.9945 26.5067 22.9825 26.5099 22.9915C26.4782 23.0066 26.256 23.0879 25.7769 23.0879C25.2914 23.0879 24.6949 22.7777 24.1142 22.4916C24.6536 22.4254 25.2819 22.3109 25.6722 22.3169ZM15.6483 25.0001C15.3659 25.4218 15.0772 25.9337 14.8075 26.2228C14.5187 26.533 14.1665 26.7588 13.8841 26.8673C13.6017 26.9727 13.4367 26.9184 13.4906 26.9456V26.9425C13.5319 26.9666 13.4811 26.9666 13.5033 26.7498C13.5224 26.536 13.6651 26.2348 13.8428 26.0722C14.1887 25.753 14.8963 25.3736 15.6483 25.0001Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 1.59286C3.75 0.937377 4.30964 0.406006 5 0.406006H25C25.3315 0.406006 25.6495 0.531049 25.8839 0.753626L35.8839 10.2484C36.1183 10.471 36.25 10.7729 36.25 11.0877V36.4072C36.25 37.0626 35.6904 37.594 35 37.594H5C4.30964 37.594 3.75 37.0626 3.75 36.4072V1.59286ZM6.25 2.77971V35.2203H33.75V11.7009H25.625V11.6811C24.9346 11.6811 24.375 11.1497 24.375 10.4942V2.77971H6.25Z"
      fill="#E50006"
    />
  </svg>
)

export const ImageFile = (props) => (
  <svg
    width="48"
    height="46"
    viewBox="0 0 48 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.0077 17.8028C34.4429 17.8049 34.8557 17.9864 35.1389 18.3001L47.1389 31.5928C47.6781 32.19 47.6052 33.0892 46.9762 33.6011C46.3472 34.1129 45.4003 34.0438 44.8612 33.4466L33.9883 21.4025L21.1289 35.3565C20.8555 35.6532 20.4649 35.829 20.05 35.8421C19.635 35.8552 19.2329 35.7045 18.9394 35.4257L12.1008 28.9327L3.15237 39.1283C2.62202 39.7326 1.67618 39.8143 1.03976 39.3107C0.403346 38.8071 0.31736 37.9091 0.847706 37.3048L10.8477 25.9111C11.1175 25.6036 11.5111 25.4182 11.9321 25.4001C12.3531 25.3819 12.7627 25.5328 13.0607 25.8157L19.927 32.3351L32.8712 18.2891C33.1578 17.9781 33.5725 17.8007 34.0077 17.8028Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 5.93425C0.5 5.14767 1.17157 4.51003 2 4.51003H46C46.8284 4.51003 47.5 5.14767 47.5 5.93425V40.1156C47.5 40.9021 46.8284 41.5398 46 41.5398H2C1.17157 41.5398 0.5 40.9021 0.5 40.1156V5.93425ZM3.5 7.35847V38.6913H44.5V7.35847H3.5Z"
      fill="#E50006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 13.0554C16.6193 13.0554 15.5 14.1181 15.5 15.4291C15.5 16.74 16.6193 17.8028 18 17.8028C19.3807 17.8028 20.5 16.74 20.5 15.4291C20.5 14.1181 19.3807 13.0554 18 13.0554ZM12.5 15.4291C12.5 12.5449 14.9624 10.2069 18 10.2069C21.0376 10.2069 23.5 12.5449 23.5 15.4291C23.5 18.3132 21.0376 20.6512 18 20.6512C14.9624 20.6512 12.5 18.3132 12.5 15.4291Z"
      fill="#E50006"
    />
  </svg>
)

export const ExternalLink = (props) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1645 1.66516L0.242394 14.5872C-0.0807981 14.9104 -0.0807981 15.4344 0.242394 15.7576C0.565587 16.0808 1.08959 16.0808 1.41278 15.7576L14.3349 2.83552V8.60332C14.3349 9.06314 14.7076 9.4359 15.1674 9.4359C15.6273 9.4359 16 9.06314 16 8.60332V0.832579C16 0.830294 16 0.828012 16 0.825731C15.9995 0.614552 15.9187 0.403519 15.7576 0.242394C15.5954 0.08017 15.3826 -0.000626887 15.1699 3.66775e-06C15.1691 1.22315e-06 15.1683 0 15.1674 0H7.39671C6.93689 0 6.56413 0.372758 6.56413 0.832579C6.56413 1.2924 6.93689 1.66516 7.39671 1.66516H13.1645Z"
      fill="currentColor"
    />
  </svg>
)

export const ChevronRight = (props) => (
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.23033 17.1704C0.832697 16.7926 0.822926 16.1619 1.20866 15.772L8.02212 8.88529L1.17544 2.0386C0.786375 1.64954 0.794491 1.01629 1.1934 0.63733C1.57685 0.273046 2.18038 0.279418 2.55606 0.651717L10.8644 8.88529L2.59687 17.1528C2.22146 17.5282 1.61524 17.536 1.23033 17.1704Z"
    />
  </svg>
)
